import { createGtm } from '@gtm-support/vue-gtm';

export default defineNuxtPlugin((nuxtApp) => {
	const config = useRuntimeConfig();
	if (!config.public.gtm.containerId) {
		return;
	}

	nuxtApp.vueApp.use(
		createGtm({
			id: config.public.gtm.containerId,
			defer: false,
			compatibility: false,
			vueRouter: useRouter(),
			trackOnNextTick: false,
			parentElement: document.head,
			source: config.public.gtm.sourceDomain + '/gtm.js' || 'https://www.googletagmanager.com/gtm.js',
		}),
	);
});
